import React, {useCallback} from "react";
import {Groups} from "apps/DRAW_PREDICTOR/modules/enums";
import {AddPrediction, SquadFlag} from "apps/DRAW_PREDICTOR/components";
import {useDispatch, useSelector} from "react-redux";
import {
	checkIsSelectedSquadByPot,
	getActivePot,
	getSelectedSquadId,
	getSquadByPositionAndGroup,
} from "apps/DRAW_PREDICTOR/modules/selectors";
import {addPrediction} from "apps/DRAW_PREDICTOR/modules/actions";
import {trackAdobeAnalytics} from "modules";
import {GroupName, PredictionWrapper} from "./Prediction";
import {showFanFact} from "apps/DRAW_PREDICTOR/modules/actions/modals";
import {getUserSupportedCountry} from "modules/selectors";
import {find} from "lodash";

interface IProps {
	group: Groups;
	position: number;
}

const GROUP_POS_TO_SHOW_FAN_FACT = [
	{group: "a", position: 2},
	{group: "e", position: 2},
	{group: "b", position: 3},
	{group: "f", position: 3},
	{group: "c", position: 4},
	{group: "g", position: 4},
];

export const NotSelectedPrediction: React.FC<IProps> = ({group, position}) => {
	const dispatch = useDispatch();
	const predictionAllowedToChange = useSelector(checkIsSelectedSquadByPot)(position, group);
	const selectedSquadId = useSelector(getSelectedSquadId);
	const selectedSquad = useSelector(getSquadByPositionAndGroup)(position, group);
	const pot = useSelector(getActivePot);
	const userSupportedCountry = useSelector(getUserSupportedCountry);

	const handleAddPrediction = useCallback(() => {
		if (selectedSquadId) {
			trackAdobeAnalytics({
				section: "",
				eventName: "drawTeamChoice",
				optional: {
					team: selectedSquad?.name || "",
					pot: `Pot ${pot}`,
					group: `Group ${group.toUpperCase()}`,
					selection: `${group.toUpperCase()}${position}`,
				},
			});

			if (
				find(GROUP_POS_TO_SHOW_FAN_FACT, {group, position}) ||
				userSupportedCountry === selectedSquad?.shortName
			) {
				dispatch(showFanFact(selectedSquadId));
			}

			dispatch(
				addPrediction({
					squadId: selectedSquadId,
					namegroup: group,
					position,
				})
			);
		}
	}, [dispatch, selectedSquadId, position, group, pot, selectedSquad, userSupportedCountry]);

	return (
		<PredictionWrapper disabled={!predictionAllowedToChange} onClick={handleAddPrediction}>
			<GroupName>
				{group}
				{position}
			</GroupName>{" "}
			<SquadFlag selectedSquad={selectedSquad} />{" "}
			<AddPrediction predictionAllowedToChange={predictionAllowedToChange} />
		</PredictionWrapper>
	);
};
